/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Roster_Not_AvailableInputs */

const en_roster_not_available = /** @type {(inputs: Roster_Not_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Roster not available.`)
};

const es_roster_not_available = /** @type {(inputs: Roster_Not_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lista no disponible.`)
};

const fr_roster_not_available = /** @type {(inputs: Roster_Not_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Liste non disponible.`)
};

const de_roster_not_available = /** @type {(inputs: Roster_Not_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teilnehmerliste nicht verfügbar.`)
};

const id_roster_not_available = /** @type {(inputs: Roster_Not_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Daftar hadir tidak tersedia.`)
};

/** @type {(inputs: Roster_Not_AvailableInputs) => LocalizedString} */
const ja_roster_not_available = en_roster_not_available;

/** @type {(inputs: Roster_Not_AvailableInputs) => LocalizedString} */
const zh_roster_not_available = en_roster_not_available;

/** @type {(inputs: Roster_Not_AvailableInputs) => LocalizedString} */
const ar_roster_not_available = en_roster_not_available;

/** @type {(inputs: Roster_Not_AvailableInputs) => LocalizedString} */
const it_roster_not_available = en_roster_not_available;

/** @type {(inputs: Roster_Not_AvailableInputs) => LocalizedString} */
const ru_roster_not_available = en_roster_not_available;

/** @type {(inputs: Roster_Not_AvailableInputs) => LocalizedString} */
const pt_roster_not_available = en_roster_not_available;

/** @type {(inputs: Roster_Not_AvailableInputs) => LocalizedString} */
const ko_roster_not_available = en_roster_not_available;

/**
* | output |
* | --- |
* | "Roster not available." |
*
* @param {Roster_Not_AvailableInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const roster_not_available = /** @type {((inputs?: Roster_Not_AvailableInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Roster_Not_AvailableInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_roster_not_available(inputs)
	if (locale === "es") return es_roster_not_available(inputs)
	if (locale === "fr") return fr_roster_not_available(inputs)
	if (locale === "de") return de_roster_not_available(inputs)
	if (locale === "ja") return ja_roster_not_available(inputs)
	if (locale === "zh") return zh_roster_not_available(inputs)
	if (locale === "ar") return ar_roster_not_available(inputs)
	if (locale === "id") return id_roster_not_available(inputs)
	if (locale === "it") return it_roster_not_available(inputs)
	if (locale === "ru") return ru_roster_not_available(inputs)
	if (locale === "pt") return pt_roster_not_available(inputs)
	return ko_roster_not_available(inputs)
});